import React from 'react';
import { Tooltip } from 'react-tooltip';
import { Link } from 'react-router-dom';
import { getLanguageText, truncateLanguageText } from '../../utils/multilanguageUtils';

const WayfinderCard = ({
  items = [],
  userId,
  buttonColor,
  placeholder,
  inputValue,
  onInputChange,
  onSubmit,
  onDelete,
  type = 'category',
  submitButtonText = 'Add',
  handleToggleVisibility,
  onViewSubCategories = null,
  onViewSubLocations = null,
  currentLanguage = 'en', // Add currentLanguage prop
}) => {
  console.log('WayfinderCard Rendered with items:', onViewSubCategories);

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    const cleanText = text.replace(/<br\s*\/?>/gi, ' ');
    return cleanText.length > maxLength ? `${cleanText.slice(0, maxLength)}...` : cleanText;
  };

  const getItemDisplayName = item => {
    if (type === 'category') {
      // Use multilanguage utility to get the name in current language
      const baseName = truncateLanguageText(item.name, 20, currentLanguage);
      const matchedName = item?.matchedCategoryName
        ? ` ${item.matchedCategoryName}`
        : item?.linkedLocation
          ? ` (${item.linkedLocation})`
          : '';
      return baseName + matchedName;
    }
    // Use multilanguage utility for other types too
    return truncateLanguageText(item.name, 20, currentLanguage);
  };

  return (
    <>
      {/* Render Items List - TriviaQuiz Style */}
      <ul className="submenu-list" style={{ minHeight: '119px' }}>
        {items.length === 0 ? (
          <li style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
            {type === 'category'
              ? 'No categories found'
              : type === 'locations'
                ? 'No locations found'
                : 'No items found'}
          </li>
        ) : (
          items.map(item => (
            <li className="submenu-item" key={item._id}>
              <span
                data-tooltip-id={`tooltip-${item._id}`}
                data-tooltip-content={getLanguageText(item.name, currentLanguage).length > 20 ? getLanguageText(item.name, currentLanguage) : ''}
              >
                {getItemDisplayName(item)}
              </span>

              <Tooltip
                id={`tooltip-${item._id}`}
                place="top"
                style={{ backgroundColor: buttonColor, zIndex: 9999 }}
                effect="float"
              />

              <div>
                {/* Visibility Toggle */}
                {item.status ? (
                  <span
                    className="bi bi-eye micon"
                    onClick={() => handleToggleVisibility(item._id, item.status)}
                  ></span>
                ) : (
                  <span
                    className="bi bi-eye-slash micon"
                    onClick={() => handleToggleVisibility(item._id, item.status)}
                  ></span>
                )}

                {/* Settings Icon */}
                <Link to={`/wayfinder-${type}/${userId}/${item._id}`}>
                  <span className="bi bi-gear micon"></span>
                </Link>

                {/* View Subcategories/Sublocations Folder Icon */}
                {type === 'category' && onViewSubCategories && (
                  <span
                    className="bi bi-folder micon"
                    onClick={() => onViewSubCategories(item)}
                    title="View Subcategories"
                  ></span>
                )}

                {type === 'locations' && onViewSubLocations && (
                  <span
                    className="bi bi-folder micon"
                    onClick={() => onViewSubLocations(item)}
                    title="View Sublocations"
                  ></span>
                )}

                {/* Delete Icon */}
                <span
                  className="bi bi-trash micon"
                  onClick={() => {
                    if (window.confirm(`Are you sure you want to delete this ${type}?`)) {
                      onDelete(item._id, type === 'category');
                    }
                  }}
                ></span>
              </div>
            </li>
          ))
        )}
      </ul>

      {/* Add New Item Input - TriviaQuiz Style */}
      <div className="form-group" style={{ display: 'flex' }}>
        <input type="text" placeholder={placeholder} value={inputValue} onChange={onInputChange} />
        <button
          style={{ backgroundColor: buttonColor }}
          className="add-btn"
          onClick={onSubmit}
          disabled={!inputValue.trim()}
        >
          {submitButtonText}
        </button>
      </div>
    </>
  );
};

export default WayfinderCard;
